import { render, staticRenderFns } from "./TutorialBlock.vue?vue&type=template&id=2ad3dd6a"
import script from "./TutorialBlock.vue?vue&type=script&lang=js"
export * from "./TutorialBlock.vue?vue&type=script&lang=js"
import style0 from "./TutorialBlock.vue?vue&type=style&index=0&id=2ad3dd6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports